import logo from './logo.svg';
import './App.css';
import { Route, Routes, HashRouter } from 'react-router-dom'
import CoPilotChat from './components/CoPilotChat';
import NavbarMain from './components/NavbarMain';
import MainPage from './components/MainPage';
//import CoPilotChat2 from './components/CoPilotChat2';




function App() {
  return (
    <div id="MasterContainer">
        <HashRouter>
          <NavbarMain />
          <Routes>
            <Route path="/" element={<CoPilotChat />}></Route>
            <Route path="/MainPage" element={<MainPage />}></Route>
            <Route path="/CoPilotChat" element={<CoPilotChat />}></Route>
            
           
          </Routes>
        </HashRouter>
      </div>
  );
}

export default App;
